import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// QR Code paket student di halaman Profile. Isinya hanya token acak dari
// server (tanpa nama, email, atau Student ID) dan dibaca oleh tim CEA saat
// pembagian paket. Gambar QR dibuat di browser — tidak ada file gambar yang
// disimpan di server.
const renderQr = async (payload) => {
  const { default: qrcode } = await import("qrcode-generator");
  const qr = qrcode(0, "M");
  qr.addData(payload);
  qr.make();
  const svg = qr.createSvgTag({ cellSize: 8, margin: 2, scalable: true });
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

const PackageQrCard = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState(null);
  // loading | ready | error
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");

  const show = async (payload) => {
    setImage(await renderQr(payload));
    setState("ready");
  };

  const load = useCallback(async () => {
    setState("loading");
    setError("");
    try {
      const res = await axios.get("/studentportal/package-qr");
      await show(res.data.payload);
    } catch (err) {
      if (err?.response?.status === 401) return navigate("/portal/login", { replace: true });
      setError(err?.response?.data?.msg || "Unable to load your QR Code right now.");
      setState("error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="sp-card sp-qr-card">
      <p className="sp-card-title">Student package QR Code</p>
      <div className="sp-qr">
        <div className="sp-qr-box" aria-busy={state === "loading"}>
          {state === "loading" && <div className="sp-qr-skeleton" aria-label="Loading your QR Code" />}
          {state === "ready" && image && <img src={image} alt="Your student package QR Code" width="220" height="220" />}
          {state === "error" && (
            <div className="sp-qr-error" role="alert">
              <i className="bi bi-exclamation-circle" aria-hidden="true"></i>
              <p>{error}</p>
              <button type="button" className="sp-btn is-ghost" onClick={load}>
                Try again
              </button>
            </div>
          )}
        </div>
        <div className="sp-qr-text">
          <p>
            Show this QR Code to the CEA team when you collect your student package (T-shirt, notebook, student ID and other items). They
            scan it to check which items you have received.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PackageQrCard;
